import { DOWNLOAD_API } from '@/api/baseUrl'
import { getToken } from '@/utils/auth'
import { handleFormData } from './handleFormData'

/**
 * @param {Array} columns 表头
 * @param {Object} requestParams 请求参数
 * @param {Function} api 请求接口
 * @param {Boolean} isConvertColumns 是否需要转换表头或者之前已处理直接使用
 * @param {Boolean} isConvertToFormData 是否需要转成formdata请求
 * @returns {Boolean}
 */
export async function exportExcel({ columns, requestParams, api, isConvertColumns = true, isConvertToFormData = false }, fileName) {
  try {
    if (isConvertColumns) {
      // 拼接成格式： {"field": "billStatus","name":"审批状态"},{"field": "base","name":"基地"}
      // exportType:'page',page:2,pagesize:10 会导出第二页的十条数据    'all' 满足查询条件的全部数据
      const exportColumns = columns.map((item) => {
        const target = {}
        target.field = item.field
        target.name = item.title
        return target
      }).filter((item) => {
        return item.name !== ''
      })
      requestParams.exportHead = exportColumns
    } else {
      requestParams.exportHead = columns
    }
    if (isConvertToFormData) {
      requestParams = handleFormData(requestParams)
    }
    const res = await api(requestParams)
    let url = ''
    if (res?.status === 1 && res?.data?.Rows[0].indexOf('xls') !== -1) {
      url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.Rows[0]
      }&authToken=${getToken()}&fileName=${fileName}`
    } else if (isConvertToFormData && res?.status === 0 && res?.data?.file.indexOf('xls') !== -1) {
      url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${fileName}`
    } else {
      return false
    }

    const link = document.createElement('a')
    document.body.appendChild(link)
    link.style.display = 'none'
    link.href = url
    // link.target = '_blank'
    link.setAttribute('download', fileName)
    link.click()
    setTimeout(function() {
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    }, 100)
  } catch (error) {
    console.log('exportExcel', error)
    return false
  }

  return true
}



// WEBPACK FOOTER //
// ./src/utils/excelExport.js